// extracted by mini-css-extract-plugin
module.exports = {"container":"Guid_container_1KKPZ","text":"Guid_text_k9Vkz","gray":"Guid_gray_hes3b"};